import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message, } from 'antd';
import RequireEdit from './RequireEdit';
import RequireCheck from './RequireCheck';
import ModalDel from '../../cpn/ModalDel';
import RequireState from './RequireState';
import { useBnsXuQiuDelMutation, useBnsXuQiuListQuery } from '../../store/BnsKeJiApi';
import ProjectSelect from '../../backend/project/ProjectSelect';

function RequireTable() {       
    const [query,setQuery] = useState({bxq_e_id:localStorage.getItem('e_id'),bxq_bg_id:''})
    const [list, setList] = useState(); 
    const {data, isSuccess} = useBnsXuQiuListQuery(query,{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bxq_id:key,bxq_name,bxq_ctime,bxq_cname,bxq_content,bxq_dept_name,bxq_state,bxq_bg_name,bxq_bgn_name} = item;
                    return item = {key,bxq_name,bxq_ctime,bxq_cname,bxq_content,bxq_dept_name,bxq_state,bxq_bg_name,bxq_bgn_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bxq_ctime;
                    let bTimeString = b.bxq_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'bxq_bg_name',
            title: '产品',
            dataIndex:'bxq_bg_name'
                
        },     
        {
            key: 'bxq_bgn_name',
            title: '客户端',
            dataIndex:'bxq_bgn_name'
                
        },     
        {
            key: 'list',
            title: '需求',
            render:(_,record) => {
                return  <RequireCheck 
                            bxq_id={record.key}
                            bxq_name={record.bxq_name}
                            bxq_content={record.bxq_content}
                        />
            }           
        },     
      
        {
            key: 'num',
            title: 'ID',            
            dataIndex: 'key',           
        },
        {
            key: 'dept',
            title: '部门',            
            dataIndex: 'bxq_dept_name',           
        },
        {
            key: 'bxq_state',
            title: '状态',            
            dataIndex: 'bxq_state',           
            render:(text) => {
                if(text==='1'){
                    return<>已实现</>
                }else{
                    return<span style={{color:'red'}}>待实现</span>
                }
            }
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bxq_ctime + record.bxq_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>  
                        <RequireEdit
                            bxq_id={record.key}
                          
                        />
                        <ModalDel onOk={() => {
                            del({bxq_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} /> 
                        <RequireState
                            bxq_id={record.key}
                            bxq_state={record.bxq_state}
                        />       
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsXuQiuDelMutation()
    return (
        <Main selectedKeys={['/RequireAdd']}> 
            <Space size='large'>
               
                <ProjectSelect
                    label='产品'
                    getProduct={(e) => {
                        setQuery(prevState=>({
                            ...prevState,
                            bxq_bg_id:e
                        }))
                    }}
                    FormStyle={{marginBottom:"0"}}
                    style={{width:'200px'}}
                />              
            </Space>          
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default RequireTable